<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>

  <div class="table-responsive">
    <table class="table table-hover table-sm">

      <thead class="table-light">
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Status</th>
          <th>Expiry</th>
        </tr>
      </thead>

      <tbody>
        @for (b of data.businesses; track b) {
          <tr>
            <td>{{ b.name }}</td>
            <td>{{ b.business_admin_email }}</td>
            <td>{{ b.status | uppercase }}</td>
            <td class="text-danger">{{ b.expiry_date | dateFormat }}</td>
          </tr>
        }

        @if (data.businesses.length === 0) {
          <tr>
            <td colspan="4" class="text-center text-muted">
              No data found
            </td>
          </tr>
        }
      </tbody>

    </table>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>